import { Card } from "./Card";
import { CHEVRON_ACTION_CLASS } from "./ChevronAction";
import { Chip } from "./Chip";
import { Eyebrow } from "./Eyebrow";
import { ChevronRightIcon } from "./icons";

export interface DrillCardProps {
    label: string;
    title: string;
    meta?: string;
    fresh?: boolean;
    onOpen: () => void;
    /** Trailing "VIEW ALL ›" label inside the card (the whole card is the button). Omitted ⇒
     *  a bare chevron. It replaces the separate "View all" link that sat above the card and
     *  went to the same place as the card itself. */
    actionLabel?: string;
}

export function DrillCard({ label, title, meta, fresh = false, onOpen, actionLabel }: DrillCardProps) {
    return (
        <section className="flex flex-col gap-2">
            <Eyebrow as="div">{label}</Eyebrow>
            <Card className="p-0">
                <button
                    type="button"
                    aria-label={title}
                    onClick={onOpen}
                    className="group flex w-full cursor-pointer items-center justify-between gap-4 rounded-[var(--radius-lg)] px-4 py-4 text-left transition-colors hover:bg-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-interactive focus-visible:ring-offset-2"
                >
                    <span className="flex min-w-0 flex-col gap-1">
                        <span className="flex items-center gap-2">
                            <span className="truncate [font:var(--type-h3)] text-primary">{title}</span>
                            {fresh ? <Chip role="success">New</Chip> : null}
                        </span>
                        {meta ? <span className="[font:var(--type-caption)] text-secondary">{meta}</span> : null}
                    </span>
                    {actionLabel ? (
                        <span aria-hidden="true" className={CHEVRON_ACTION_CLASS}>
                            {actionLabel}
                            <ChevronRightIcon />
                        </span>
                    ) : (
                        <ChevronRightIcon className="shrink-0 text-tertiary" />
                    )}
                </button>
            </Card>
        </section>
    );
}
